export default __webpack_public_path__ + "static/media/thumbnail.cd305a62.jpg";